import {Dropdown, IDropdown} from "components/Layout/Dropdown/Dropdown.Component";
import {IconButton} from "@material-ui/core";
import * as React from "react";

export interface ISidebarHeader {
  onBack: () => void
  label: string
  dropdown: IDropdown
}

export const SidebarHeader = ({
  onBack,
  dropdown,
  label
}: ISidebarHeader) => (
  <div className="sidebar__header">
    <IconButton id="back-button" className="sidebar__back-button" onClick={onBack} disableRipple>
      <img src="/images/icons/chevron_left.svg" alt="Back button"/>
    </IconButton>
    <label htmlFor="back-button">
      {label}
    </label>
    <Dropdown {...dropdown} />
  </div>
)

export default SidebarHeader



// WEBPACK FOOTER //
// ./src/components/Layout/SidebarHeader/SidebarHeader.Component.tsx